var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "active-tabs-container" }, [
    _vm.tabList.length > 10
      ? _c("i", {
          staticClass: "icon-left fa fa-chevron-left",
          on: { click: _vm.slideLeft }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-container", style: _vm.tabStyle },
      _vm._l(_vm.tabList, function(item, index) {
        return _c(
          "el-tag",
          {
            key: item.menu_id,
            staticClass: "active-tabs",
            attrs: {
              type: item.route_url === _vm.activeTab ? "success" : "",
              closable: ""
            },
            on: {
              click: function($event) {
                return _vm.toggleTabs(item, index)
              },
              close: function($event) {
                return _vm.closeTabs(item)
              }
            }
          },
          [_vm._v(_vm._s(item.menu_name))]
        )
      }),
      1
    ),
    _vm._v(" "),
    _vm.tabList.length > 10
      ? _c("i", {
          staticClass: "icon-right fa fa-chevron-right",
          on: { click: _vm.slideRight }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37c8bb8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c8bb8f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActiveTabs/ActiveTabs.vue
// module id = null
// module chunks = 